export const medicineUnits = [
  // Ordered by smallest to largest
  // Spec: https://jira.bbraun.com/browse/GRAVPL-1006
  { id: 'microgram', label: 'µg' },
  { id: 'milligram', label: 'mg' },
  { id: 'gram', label: 'g' },
  { id: 'milliliter', label: 'mL' },
  { id: 'percentage', label: '%' },
  { id: 'mole', label: 'mmol' },
  { id: 'iu', label: 'IU' }
];
